import { Box, Container, List, ListItem, ListItemText, Typography } from "@mui/material";

const AccessControlRights: React.FC = () => {
    return (
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Box mb={4}>
          <Typography variant="h4" gutterBottom>
            4. Direito de Acessar e Controlar Seus Dados Pessoais
          </Typography>
          <Typography variant="body1" paragraph>
            A INNOVA PLANO DE SAÚDE LTDA, em conformidade com o disposto no artigo 18 da Lei Geral de Proteção de Dados (Lei nº
            13.709/2018), assegura aos seus usuários e clientes o pleno exercício dos direitos de titular, os quais podem ser exercidos, de
            forma gratuita e a qualquer momento, mediante solicitação formal. São garantidos os seguintes direitos:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="Confirmação da existência de tratamento de dados" secondary="Possibilidade de solicitar a confirmação de maneira simplificada ou em formato claro e completo, conforme a necessidade do titular." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Acesso aos dados pessoais" secondary="Direito de obter uma cópia integral e legível de seus dados pessoais, em formato impresso ou eletrônico, seguro e adequado." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Correção de dados pessoais" secondary="Possibilidade de solicitar a edição, correção ou atualização de informações pessoais imprecisas, desatualizadas ou incompletas." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Anonimização, bloqueio ou eliminação" secondary="Direito de limitar o tratamento ou solicitar a exclusão de dados considerados desnecessários, excessivos ou tratados em desconformidade com a legislação aplicável." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Portabilidade de dados pessoais" secondary="Direito de solicitar a transferência de seus dados a outro fornecedor de serviço ou produto, mediante requisição formal, observados os segredos comercial e industrial." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Revogação do consentimento" secondary="Possibilidade de retirar o consentimento previamente concedido, interrompendo o tratamento de seus dados, salvo nas hipóteses legais que autorizem sua continuidade." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Informação sobre a negativa de consentimento" secondary="Direito de ser informado sobre a opção de não fornecer consentimento e as respectivas consequências, sendo certo que, em alguns casos, a ausência de autorização pode comprometer a administração e a prestação eficaz dos serviços contratados." />
            </ListItem>
          </List>
          <Typography variant="body1" paragraph>
            A INNOVA PLANO DE SAÚDE LTDA mantém-se à disposição para esclarecer dúvidas e atender solicitações relacionadas ao exercício
            de tais direitos, reafirmando seu compromisso com a proteção de dados pessoais e a transparência no relacionamento com seus
            clientes e usuários.
          </Typography>
        </Box>
      </Container>
    );
  };
  
  export default AccessControlRights;
  